export default __webpack_public_path__ + "static/case1_img_4@2x-3b1c1a0e02176509acaa145271b76b80.webp";